// OneDrive:CoverageThreshold(75)

export * from '@ms/telemetry-manager/lib/PairedEventBase';
